var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"day"},[_c('div',{staticClass:"day__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"day__subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }